var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c("p", { attrs: { id: "overrideIntro" } }, [
      _vm._v("Je wilt "),
      _c("strong", [_vm._v(_vm._s(_vm.attendant.name))]),
      _vm._v(" inplannen op "),
      _c("strong", [_vm._v(_vm._s(_vm.item.title))]),
      _vm._v("."),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { attrs: { id: "overrideIssues" } },
      [
        _vm._l(_vm.list, function (val) {
          return _c(
            "div",
            { staticClass: "issue", class: val.zeroHour == false ? "red" : "" },
            [
              val.zeroHour
                ? _c(
                    "font",
                    {
                      staticStyle: { "vertical-align": "inherit" },
                      attrs: { dir: "auto" },
                    },
                    [
                      _c(
                        "font",
                        {
                          staticStyle: { "vertical-align": "inherit" },
                          attrs: { dir: "auto" },
                        },
                        [
                          _vm._v(
                            "Slechts 0.0 uur rust na " +
                              _vm._s(_vm.item.title) +
                              "."
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !val.zeroHour
                ? _c(
                    "font",
                    {
                      staticStyle: { "vertical-align": "inherit" },
                      attrs: { dir: "auto" },
                    },
                    [_vm._v("Dubbele dienst: overlap met " + _vm._s(val.title))]
                  )
                : _vm._e(),
            ],
            1
          )
        }),
        _vm._v(" "),
        _vm.attendant.contractType == 0
          ? _c(
              "div",
              { staticClass: "issue" },
              [
                _c(
                  "font",
                  {
                    staticStyle: { "vertical-align": "inherit" },
                    attrs: { dir: "auto" },
                  },
                  [
                    _c(
                      "font",
                      {
                        staticStyle: { "vertical-align": "inherit" },
                        attrs: { dir: "auto" },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.attendant.name) +
                            "  heeft zich niet beschikbaar gesteld en heeft hier geen contractafspraak.\n                "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ],
      2
    ),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c("label", { staticClass: "form-field" }, [
      _vm._v("\n        Reden voor override\n        "),
      _c("textarea", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.reason,
            expression: "reason",
          },
        ],
        attrs: {
          id: "overrideReason",
          required: "",
          rows: "3",
          placeholder:
            "Bijvoorbeeld: telefonisch afgestemd en akkoord locatiemanager.",
        },
        domProps: { value: _vm.reason },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.reason = $event.target.value
          },
        },
      }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "modal-actions" }, [
      _c(
        "button",
        {
          staticClass: "btn close-modal",
          attrs: { "data-modal": "overrideModal" },
          on: { click: _vm.dismiss },
        },
        [_vm._v(_vm._s(_vm.$t("actions.cancel")))]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn danger",
          attrs: { id: "confirmOverride" },
          on: { click: _vm.save },
        },
        [_vm._v(_vm._s(_vm.$t("actions.schduleitanyway")))]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", { staticStyle: { "font-size": "11px" } }, [
      _c("strong", [_vm._v("De beheerder kan altijd doorgaan.")]),
      _vm._v(" De afwijking wordt vastgelegd in het logboek."),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }